// extracted by mini-css-extract-plugin
module.exports = {"div_form":"Form_div_form__2DAeG","input":"Form_input__1bOSM","input_submit":"Form_input_submit__1Pl6c"};